import Vue from "vue";
import ApiService from "../common/api.service";
import {
  CollectionsService,
} from "../common/api.service";
import {

  COLLECTIONS_RESET_STATE,
  COLLECTION_RESET_STATE,
  FETCH_EXPCLIENT_COLLECTIONS,
  FETCH_COLLECTION,
  COLLECTION_ALTER_SHARE,
  COLLECTION_SET_BY_OBJ,

  PHOTOS_PUBLISH,

  COLLECTIONS_REMOVE_COLLECTION
} from "./actions.type";
import {
  RESET_STATE,
  SET_COLLECTION,

  SET_EXPCLIENT_COLLECTIONS,
  RESET_STATE_ITEM,
  ALTER_COLLECTIONS_COLECTION,

  SET_PHOTO_SEARCH_RESULT,
  REMOVE_COLLECTION
} from "./mutations.type";

const initialState = {
  collection: {
    id: "", client_id: "", name: "", is_collection_sharable: false, is_shared_collection: false,
    owner: {},
    shared_with_clients:[],
  },
  collections: [],
  page: 1,
  addToCollectionLoading: false,
};

export const state = {
  ...initialState
};

export const actions = {
  /**
   * Get a single collection
   * @param {*} context
   * @param {*} payload
   */
  async [FETCH_COLLECTION](context, payload) {
    let params = {
      client_id: payload.clientId,
      page: state.page
    }

    const {
      data
    } = await ApiService.query("collections/" + payload.collectionId, { params: params });

    console.log(data, 'Collection');
    context.commit(SET_COLLECTION, data);

    return data;
  },

  /**
   * Get a users Collections.
   * @param {*} context
   * @param {*} payload
   */
  async [FETCH_EXPCLIENT_COLLECTIONS](context, payload) {
    let params = payload

    params.page = state.page
    console.log(params);
    console.log(payload);
    if (payload.client_created) params.client_created = 1

    const {
      data
    } = await ApiService.query("collections", { params: params })

    // Remove previouse results.
    if (state.page === 1) {
      context.commit(RESET_STATE_ITEM, 'collections')
    }

    context.commit(SET_EXPCLIENT_COLLECTIONS, data.data);
    state.page += 1
    if (state.page > data.last_page) return 'complete'
    return data;
  },

  /**
   * Remove collection from the collectioins state object.
   * @param {*} context
   * @param {*} payload
   */
  [COLLECTIONS_REMOVE_COLLECTION](context, payload) {
    context.commit(REMOVE_COLLECTION, payload)
  },

  /**
   * Set a share on a
   * @param {*} context
   * @param {*} payload
   */
  [COLLECTION_ALTER_SHARE](context, payload) {
    state.collections = state.collections.filter(t => t !== payload.collection);
    context.commit(ALTER_COLLECTIONS_COLECTION, {index: payload.index, value: payload.shares, collectionParam: 'shared_with'})
  },

  [COLLECTION_SET_BY_OBJ] (context, payload) {
    context.commit(SET_COLLECTION, payload);

    if (state.collections.length) {
      const collectionIndex = state.collections.findIndex(t => t.id === payload.id);

      if (collectionIndex) {
        console.log('index', collectionIndex);
        context.commit(ALTER_COLLECTIONS_COLECTION, { index: collectionIndex, collection: payload })
      }
    }
  },

  [COLLECTIONS_RESET_STATE] ({ commit }) {
    commit(RESET_STATE_ITEM, 'page')
    commit(RESET_STATE_ITEM, 'collections')
  },

  [COLLECTION_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {

  // Set collection
  [SET_COLLECTION](state, collection) {
    return state.collection = collection;
  },

  [SET_EXPCLIENT_COLLECTIONS](state, collections) {
    state.collections = state.collections.concat(collections);
  },

  [REMOVE_COLLECTION](state, payload) {
    state.collections = state.collections.filter(t => t !== payload.collection);
  },

  [ALTER_COLLECTIONS_COLECTION](state, payload) {
    console.log(state.collections[payload.index]);
    state.collections[payload.index]= payload.collection
  },

  [RESET_STATE_ITEM](state, item) {
    state[item] = initialState[item]
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

const getters = {
  collection(state) {
    return state.collection;
  },
  collections(state) {
    return state.collections;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
